window.addEventListener("DOMContentLoaded", () => {
   class TabElement extends HTMLElement {
      constructor() {
         super();
         this.navigators = [...this.querySelectorAll("[tab-navigator]")];
         this.contents = [...this.querySelectorAll("[tab-content]")];
   
         this.navigators.forEach(nav => {
            nav.addEventListener("click", (e) => {
               let target = e.currentTarget.getAttribute("data-target");
               let targetContent = [...this.querySelectorAll("." + target)];
               
               let currentActive = [...this.querySelectorAll(".active")];
               currentActive.forEach(item => item.classList.remove("active"));

               e.currentTarget.classList.add("active");
               targetContent.forEach(item => item.classList.add("active"));
            });
         })
      }
   }
   customElements.define("tab-element", TabElement);
})